import "./AboutSection.css";
import React from "react";
import { BsTwitter } from "react-icons/bs";
import { AiFillInstagram, AiFillLinkedin } from "react-icons/ai";
import { FaTelegramPlane } from "react-icons/fa";
import { NavLink } from "react-router-dom";

const AboutSection = () => {
  return (
    <>
      <div className="about">
        <div className="info">
          <h2>
            HI🖐 I'M <span> CHANDAN SINGH</span>
          </h2>
          <p>engineering student</p>
          <p className="briefaboutme">
            Heloo! my name is chandan singh,living in uttrakhand,bageshwar.I am
            passionate in web development and buildings a interactive websites
            and web applications & commit to code
            <a href="https://github.com/chandan-singh02">Github</a>
            .I spend my almost 4 and 5days in week with my hands on diffrent
            areas of fronted and backend. areas
          </p>
          <p>Currently I,m learning-: </p>
          <ul>
            <li>-Node js</li>
          </ul>
          <div className="intrest">Active On</div>
          <div class="socials">
            <ul>
              <li>
                <FaTelegramPlane className="socials-btn tele" />
              </li>
              <li>
                <a href="https://www.instagram.com/killjoy__02/">
                  <AiFillInstagram className="socials-btn insta  "></AiFillInstagram>
                </a>
              </li>
              <li>
                <a href="https://twitter.com/killjoy__02">
                  <BsTwitter className="socials-btn tweet" />
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/chandan-singh-21a837208/">
                  <AiFillLinkedin className="socials-btn linkdn" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <ul className="hobbies">
          <h2>Intrest-</h2>
          <li> Music/Gaming</li>
          <li>Popular Tv Shows</li>
          <li>Try to learn new things</li>
        </ul>
      </div>
    </>
  );
};

export default AboutSection;
